import { model, ListModel, createThunk } from 'mst-collection';

import { SectionModel } from './SectionModel';
import { Api, schemas, SectionTypeEnum } from '@api';

export class LatestSectionsList extends ListModel(SectionModel, {
  schema: schemas.SectionListSchema,
}) {
  fetch = createThunk(() => {
    return async function fetch(this: LatestSectionsList) {
      const types = [
        SectionTypeEnum.Tutorial,
        SectionTypeEnum.Course,
      ];

      const res = await Api.Sections.getLatestSections({
        types,
      });

      this.set(res.data.sections);
    };
  });
}

export const LatestSectionsListModel = model(LatestSectionsList);
